import type { CSSProperties, ImgHTMLAttributes, ReactNode } from "react";
import { DEFAULT_MEDIA_PRESENTATION, isHexColor, normalizeMediaPresentation, type MediaPresentation } from "../domain/project";
import { SafeImage } from "./SafeImage";

interface PhotoFrameProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {
  src?: string;
  alt: string;
  presentation?: Partial<MediaPresentation>;
  placeholder?: ReactNode;
  className?: string;
}

export function PhotoFrame({ src, alt, presentation, placeholder, className = "", style, ...imageProps }: PhotoFrameProps) {
  const resolved = normalizeMediaPresentation(presentation, DEFAULT_MEDIA_PRESENTATION);
  const safeColor = resolved.frameColor && isHexColor(resolved.frameColor) ? resolved.frameColor : undefined;
  const frameStyle = {
    ...style,
    ...(safeColor ? { "--media-frame-color": safeColor } : {}),
  } as CSSProperties;

  return (
    <div
      className={`media-frame media-frame-spacing-${resolved.spacing}${className ? ` ${className}` : ""}`}
      data-fit={resolved.fit}
      data-frame={resolved.frame}
      style={frameStyle}
    >
      {src ? <SafeImage {...imageProps} src={src} alt={alt} className="media-frame-image" /> : placeholder ?? <div className="image-skeleton" aria-label="正在加载照片" />}
    </div>
  );
}
